module.exports = __webpack_public_path__ + "img/已抢到.782f8289.png";